import { Button } from '@mui/material';
import styles from './buttonstyles';

const CustomButton = (props: any) => {
  const classes = styles();

  return (
    <>
      <Button
        variant={props?.variant ? props?.variant : 'contained'}
        style={{
          background: `${props.color}`,
          color: `${props.color === '#fff' && 'black'}`,
        }}
        className={`${props.className} ${classes.button} `}
        onClick={props.onClick}
        // color={props.color}
        size={props?.size}
        type={props?.type}
        fullWidth={props?.fullWidth}
        sx={{ ...props.sx }}
        disabled={props?.disabled}
      >
        {props.children}
      </Button>
    </>
  );
};

export default CustomButton;
